export function validateEmail(email) {
  const regex = /^([\a-z0-9\+\-_]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i
  return regex.test(email)
}
